module.exports = __webpack_public_path__ + "img/henkel-natco.607e6565.jpg";